import cloneDeep from 'lodash/cloneDeep';

export const state = {
  isAdminPanelActive: false,
  panelContent: null,
  adminPanelError: null,
};

export const getters = {
  isAdminPanelActive(state) {
    return state.isAdminPanelActive;
  },
};

export const mutations = {
  setShowAdminPanel(state) {
    state.isAdminPanelActive = true;
  },
  setPanelContent(state, value) {
    state.panelContent = value;
  },
  setHideAdminPanel(state) {
    state.isAdminPanelActive = false;
  },
  setAdminPanelError(state, value) {
    state.adminPanelError = value;
  },
  setHidePanelContentDetail(state) {
    const panelContentClone = cloneDeep(state.panelContent);

    if (panelContentClone && panelContentClone.data && panelContentClone.data.componentRight) {
      panelContentClone.data.componentRight.showPanelDetail = false;
    }

    if (panelContentClone && panelContentClone.data && panelContentClone.data.details) {
      panelContentClone.data.details = null;
    }
    state.panelContent = panelContentClone;
  },
};

export const actions = {};
